import { colors } from '../styles'

const Link = {
  baseStyle: {
    color: colors.appClearBlue,
    fontSize: '14px',
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: '500',
    letterSpacing: 'normal',
    textAlign: 'left',
  },
  sizes: {},
  variants: {
    disabled: {
      color: colors.appBlueyGrey,
    },
  },
}

export default Link
